import {
    Box,
    Button,
    CardActions,
    CardContent,
    CardHeader,
    Dialog,
    Typography,
} from "@mui/material";
import {
    CANCEL,
    HELP_TEXT,
    OPEN_MAILTO,
    SUPPORT_EMAIL,
    SUPPORT_HEADER,
} from "./UserVisibleStrings";
import React, { useEffect, useState } from "react";
import { CognitoIdTokenPayload } from "aws-jwt-verify/jwt-model";
import { getIdToken, idVerifier } from "../app/auth";
import { useGetVersionQuery } from "../services/riskSurface";
import Bowser from "bowser";


type ButtonProps = {
    readonly Subject: string,
    readonly Body: string,
    readonly onClose: () => void,
    readonly open: boolean,
};

function openEmail( subject: string, body: string )
{
    window.open(
        `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${encodeURIComponent( body )}`
    );
}

function createSupportPopup(
    onCancel: () => void,
    onEmail: () => void,
    emailText: string
)
{
    return (
        <React.Fragment>
            <CardHeader title = {SUPPORT_HEADER}/>
            <CardContent>
                <Box
                    sx = {{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        alignItems: "start",
                    }}
                >
                    <Box
                        sx = {{
                            display: "grid",
                            gridTemplateColumns: "auto auto",
                            columnGap: 3,
                            rowGap: 3,
                        }}
                    >
                        <Typography sx = {{ whiteSpace: "pre-wrap" }}>
                            {HELP_TEXT}
                            {emailText}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
            <CardActions sx = {{ justifyContent: "right" }}>
                <Button variant = "contained" onClick = {() => onEmail()} color = "primary">
                    {OPEN_MAILTO}
                </Button>
                <Button
                    variant = "contained"
                    onClick = {() => onCancel()}
                    color = "secondary"
                >
                    {CANCEL}
                </Button>
            </CardActions>
        </React.Fragment>
    );
}

export default function SupportDialog( props: ButtonProps )
{
    const [ identity, setIdentity ] = useState<CognitoIdTokenPayload | null>( null );

    const { data: version, isLoading, error } = useGetVersionQuery();

    if ( error )
    {
        console.error( "Error: ", error );
    }
    const idToken = getIdToken();
    useEffect( () =>
    {
        async function verifyId()
        {
            if ( idToken !== null )
            {
                try
                {
                    const payload = await idVerifier.verify( idToken );
                    setIdentity( payload );
                }
                catch ( err )
                {
                    setIdentity( null );
                }
            }
        }

        void verifyId();
    }, [ idToken ] );

    const userID = String( identity?.["custom:id"] );
    const user = identity?.identities[0].userId;

    const browser = Bowser.getParser( window.navigator.userAgent );

    const browserName = browser.getBrowserName();
    const browserVersion = browser.getBrowserVersion();

    const subject = props.Subject + " - From:" + ( user ?? "Unknown User" );
    const body =
    `Browser: ${browserName} version ${browserVersion}\n` +
    `Version: ${version ?? ( isLoading ? "loading" : "failed to load" )}\n` +
    `User: ${user ?? "Missing"} - (${userID ?? "ID Missing"})\n` +
    props.Body;

    return (
        <Dialog fullWidth maxWidth = "md" open = {props.open}
            onClick = {( event ) =>
            {
                event.stopPropagation();
            }}
        >
            {createSupportPopup(
                () => props.onClose(),
                () => openEmail( subject, body ),
                "\n" + body
            )}
        </Dialog>
    );
}
